import {Setting} from "./Setting";

export const economicSetting: Setting = {
    key: "Economic",
    title: "Экономика",
    description: `Экономика играет ключевую роль в создании мира и в том, как игроки взаимодействуют с ним. Экономическая система определяет ресурсы, способы торговли, богатство или бедность регионов и влияет на отношения между фракциями и персонажами. Она может быть основана на реальных принципах экономики или быть фантастической, с уникальными механизмами.`,
    components: [
        {
            title: "Ресурсы и сырьё",
            subComponents: [
                {
                    title: "Минералы и металлы",
                    description: `Железо, золото, серебро, драгоценные камни, магические кристаллы.`,
                    examples: ["Золотые рудники в горах, добыча драгоценных камней в пещерах."]
                },
                {
                    title: "Энергетические ресурсы",
                    description: `Руда, нефть, магические источники энергии, солнечные или звездные элементы.`,
                    examples: ["Магические источники, питающие города и машины."]
                },
                {
                    title: "Продукты питания",
                    description: `Зерно, мясо, рыба, редкие растения и грибы.`,
                    examples: ["Фермы, производящие зерно и мяcо для городов."]
                },
                {
                    title: "Животные и растения",
                    description: `Леса с деревьями, дающими особую древесину или растения с магическими свойствами.`,
                    examples: ["Леса, где растут магические растения."]
                },
                {
                    title: "Магические ресурсы",
                    description: `Энергия, витающая в воздухе, магические камни, алхимические ингредиенты.`,
                    examples: ["Кристаллы, используемые для создания магических предметов."]
                }]
        },
        {
            title: "Экономические системы",
            subComponents: [
                {
                    title: "Товарно-денежная система",
                    description: `Использование монет, кредитов, бумажных денежных единиц или других средств обмена.`,
                    examples: ["Торговля монетами, обмен ресурсами"]
                },
                {
                    title: "Бартер",
                    description: `Обмен товаров без использования денег (например, магические артефакты, услуги).`,
                    examples: ["Торговля ресурсами, услугами или знаниями.", "Обмен магическими предметами."]
                },
                {
                    title: "Государственные деньги",
                    description: `Использовdние монет, чеков или фиатных валют, выпущенных государствами или правителями.`,
                    examples: ["Монеты с гербом короля, бумажные деньги."]
                },
                {
                    title: "Неформальная экономика",
                    description: `Черный рынок, контрабанда, преступные сделки.`,
                    examples: ["Теневая торговля, нелегальные сделки."]
                }]
        },
        {
            title: "Производство и индустрия",
            subComponents: [
                {
                    title: "Мануфактуры",
                    description: `Строительные материалы, оружие, магические предметы, одежда, сельскохозяйственная продукция.`,
                    examples: ["Фабрики, производящие магические предметы."]
                },
                {
                    title: "Гильдии и мастерские",
                    description: `Мастера кузнечного дела, маги, алхимики, создатели искусных артефактов.`,
                    examples: ["Гильдия алхимиков, производящая лечебные зелья."]
                },
                {
                    title: "Сельское хозяйство",
                    description: `Земледелие, пастбища, животноводство, рыболовство.`,
                    examples: ["Фермы, производящие продукты питания."]
                },
                {
                    title: "Торговля и карго",
                    description: `Торговые пути, грузоперевозки, экспорты и импорты.`,
                    examples: ["Торговые корабли, перевозящие товары."]
                }]
        },
        {
            title: "Торговля и рынок",
            subComponents: [
                {
                    title: "Локальные рынки",
                    description: `Торговля на рынках городов, деревень, и уважаемых торговцев.`,
                    examples: ["Рынок, где продаются местные товары."]
                },
                {
                    title: "Международная торговля",
                    description: `Сетевые торговли между странами, использование дорог и морских путей.`,
                    examples: ["Торговля между государствами, обмен ресурсами."]
                },
                {
                    title: "Ценные товары",
                    description: `Драгоценности, редкие ресурсы или магические предметы, представляющие ценность для игроков.`,
                    examples: ["Торговля магическими предметами."]
                }]
        },
        {
            title: "Рабочая сила и классы",
            subComponents: [
                {
                    title: "Рабочие классы",
                    description: `Крестьянство, ремесленники, шахтеры, рабочие на фабриках.`,
                    examples: ["Фермеры, работающие на полях."]
                },
                {
                    title: "Элита",
                    description: `Бизнесмены, аристократы, маги высокого уровня, торговцы ценными товарами.`,
                    examples: ["Торговцы, торгующие драгоценностями."]
                },
                {
                    title: "Рабство и принудительный труд",
                    description: `Угроза рабства, принудительного труда, или заключенные на тяжелых работах (например, в шахтах).`,
                    examples: ["Рабы, работающие на галерах."]
                }]
        },
        {
            title: "Экономические отношения",
            subComponents: [
                {
                    title: "Торговые союзы и альянсы",
                    description: `Формирование торговых соглашений между фракциями, странами или гильдиями.`,
                    examples: ["Договоры о торговле и защите."]
                },
                {
                    title: "Конкуренция",
                    description: `Конкуренция между крупными корпорациями, магическими орденами, торговыми домами.`,
                    examples: ["Борьба за ресурсы и рынки."]
                },
                {
                    title: "Коррупция и манипуляции",
                    description: `Подкуп, взяточничество, мафиозные структуры, контроль над рынками.`,
                    examples: ["Взяточничество, контрабанда."]
                }]
        }
    ],
    prompt: {
        component: {
            single: 'Сгенерируй компонент экономики для мира. Опиши ключевые аспекты, структуры и экономические взаимодействия.',
            list: 'Перечисли возможные компоненты экономики и опиши их если они применимы к истории. Не ограничивайся основными компонентами если необходимо',
            extend: 'Дополни описание компонента экономики и разбей на абзацы. Как компонент влияет на мир и персонажей.'
        },
        element: {
            single: 'Сгенерируй элемент экономики для мира. Опиши ключевые аспекты, структуры и экономические взаимодействия.',
            list: 'Перечисли возможные элементы экономики и опиши их если они применимы к истории. Не ограничивайся основными элементами если необходимо',
            extend: 'Дополни описание элемента экономики и разбей на абзацы. Как элемент влияет на мир и персонажей.'
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента экономики. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента экономики. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора экономики и разбей на абзацы."
        },
    }
}